// NOTE: This file is imported into the react4xp build, don't import node modules here.

export const ACCEPT_APPLICATION_JSON = 'application/json';

export const CONTENT_TYPE_APPLICATION_JSON_UTF8 = 'application/json;charset=UTF-8';
